module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0018.jpg?v=9f1bd861";